import { URL_BASE } from 'constants/routes';

import { Locale } from '@skippay/core/@types/country';

const CS_CONTACTS = {
	email: 'info@skippay.cz',
	phone: {
		phoneType: 'CONTACT',
		countryCode: '+420',
		number: '226288700',
	},
	url: URL_BASE.CZ.url,
};

const SK_CONTACTS = {
	email: 'info@skippay.sk',
	phone: {
		phoneType: 'CONTACT',
		countryCode: '+421',
		number: '220512026',
	},
	url: URL_BASE.SK.url,
};

const HU_CONTACTS = {
	email: 'info@skippay.hu',
	phone: null,
	url: URL_BASE.HU.url,
};

export const CONTACTS = (locale: Locale = 'cs') => {
	switch (locale) {
		case 'cs':
			return CS_CONTACTS;
		case 'sk':
			return SK_CONTACTS;
		case 'hu':
			return HU_CONTACTS;
		default:
			throw new Error('Locale is not supported yet');
	}
};
